export default __webpack_public_path__ + "static/media/mutton_shoulder.a63ceb09.png";